import * as SessionActions from "../actions/session";

const defaultState = {
	hasFetchedInfo: false,
	isLoggingIn: false,
	isLoggingOut: false,
	error: null,
	user: {}
};

const session = (state = defaultState, action) => {
	const {type} = action;

	switch (type) {
		case SessionActions.SESSION_INFO_REQUEST:
			return {
				...state
			};
		case SessionActions.SESSION_INFO_SUCCESS:
			return {
				...state,
				user: action.response.data,
				hasFetchedInfo: true
			};
		case SessionActions.SESSION_INFO_FAILURE:
			return {
				...state
			};
		case SessionActions.SESSION_LOGIN_REQUEST:
			return {
				...state,
				error: null,
				isLoggingIn: true
			};
		case SessionActions.SESSION_LOGIN_SUCCESS:
			return {
				...state,
				user: action.response.data,
				isLoggingIn: false
			};
		case SessionActions.SESSION_LOGIN_FAILURE:
			return {
				...state,
				error: action.error ? action.error : "Přihlášení selhalo",
				isLoggingIn: false
			};
		case SessionActions.SESSION_CHANGE_PASSWORD_REQUEST:
			return {
				...state,
				error: null,
				isLoggingIn: true
			};
		case SessionActions.SESSION_CHANGE_PASSWORD_SUCCESS:
			return {
				...state,
				isLoggingIn: false
			};
		case SessionActions.SESSION_CHANGE_PASSWORD_FAILURE:
			return {
				...state,
				error: action.error ? action.error : "Obnova hesla selhala", // XXX
				isLoggingIn: false
			};
		case SessionActions.SESSION_FORGOTTEN_PASSWORD_REQUEST:
			return {
				...state,
				error: null,
				isLoggingIn: true
			};
		case SessionActions.SESSION_FORGOTTEN_PASSWORD_SUCCESS:
			return {
				...state,
				isLoggingIn: false
			};
		case SessionActions.SESSION_FORGOTTEN_PASSWORD_FAILURE:
			return {
				...state,
				error: action.error ? action.error : "Obnova hesla selhala", // XXX
				isLoggingIn: false
			};
		case SessionActions.SESSION_LOGOUT_REQUEST:
			return {
				...state,
				isLoggingOut: true
			};
		case SessionActions.SESSION_LOGOUT_SUCCESS:
			return {
				...state,
				user: {},
				isLoggingOut: false
			};
		case SessionActions.SESSION_LOGOUT_FAILURE:
			return {
				...state,
				isLoggingOut: false
			};
		default:
			return state
	}
};

export default session